import type {FC} from 'react';
import {useRef, useState} from 'react';
import {Link} from 'react-router';

import {action, observable} from 'mobx';
import {Observer} from 'mobx-react';

import {Logo} from '@yourcoach/shared/uikit/Logo';

import BurgerButton from '@src/components/BurgerButton/BurgerButton';
import MainMenu from '@src/modules/MainMenu/MainMenu';
import {MainMenuFooter} from '@src/modules/MainMenu/MainMenuFooter';
import {routerPath} from '@src/routes/path';

interface ILocalStore {
  isMenuOpen: boolean;
  setToggleMenu(val: boolean): void;
}

interface Props {}

const MainMenuLayout: FC<Props> = () => {
  const localStore: ILocalStore = useRef(
    observable(
      {
        isMenuOpen: false,
        setToggleMenu(val: boolean) {
          this.isMenuOpen = val;
        },
      },
      {
        isMenuOpen: observable,
        setToggleMenu: action,
      },
    ),
  ).current;

  const handleOnClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    e.preventDefault();

    localStore.setToggleMenu(!localStore.isMenuOpen);
  };

  const [menuOpened, setMenuOpened] = useState(false);

  return (
    <Observer>
      {() => (
        <>
          <div
            className={`navbarVerticalLeftBack ${
              localStore.isMenuOpen ? 'show' : ''
            }`}
          />
          <nav
            className={`navbar navbarVerticalLeft ${
              localStore.isMenuOpen ? '' : 'hide'
            }`}
            onMouseEnter={() => setMenuOpened(true)}
            onMouseLeave={() => setMenuOpened(false)}
          >
            <Link className="logoContainer" to={routerPath.$buildPath({})}>
              <Logo size={30} variant={menuOpened ? 'text' : undefined} />
            </Link>
            <div className="BurgerButContainer">
              <BurgerButton
                isOpen={localStore.isMenuOpen}
                onClick={handleOnClick}
              />
            </div>
            <MainMenu menuOpened={menuOpened} />
            <MainMenuFooter isMenuOpened={menuOpened} />
          </nav>
          <div />
        </>
      )}
    </Observer>
  );
};

export default MainMenuLayout;
